import { Page, Header, Content } from '@backstage/core-components';
import { CatalogTable } from '@backstage/plugin-catalog';
import {
  EntityListProvider,
  CatalogFilterLayout,
  EntityKindPicker,
  UserListPicker,
} from '@backstage/plugin-catalog-react';
import CatalogLogo from '../../assets/catalog-puzzle-logo.svg';

export const CustomCatalogPage = () => {
  return (
    <Page themeId="home">
      <Header
        pageTitleOverride="Puzzle Catalog"
        title={
          <img
            src={CatalogLogo}
            alt="Puzzle Catalog"
            style={{ height: '40px', width: 'auto' }}
          />
        }
      />
      <EntityListProvider>
        <Content>
          <CatalogFilterLayout>
            <CatalogFilterLayout.Filters>
              <EntityKindPicker initialFilter="component" hidden />
              <UserListPicker initialFilter="all" />
            </CatalogFilterLayout.Filters>

            <CatalogFilterLayout.Content>
              <CatalogTable />
            </CatalogFilterLayout.Content>
          </CatalogFilterLayout>
        </Content>
      </EntityListProvider>
    </Page>
  );
};
